import { AgChartOptions } from "@ag-grid-community/core";
import { compareAsc, isMatch, parse } from "date-fns";

interface DataObjDict {
  date: Date;
  key: string;
  count: number;
  isDisplayed: boolean;
}

export const getCasesCountOptions = (
  gridRef: any,
  lookup_key: string
): AgChartOptions | null => {
  const gridApi = gridRef?.current?.api;

  if (!gridApi) {
    return null;
  }

  const dataIn = getCaseTotalData(gridApi, lookup_key);

  const chartOptions: AgChartOptions = {
    autoSize: true,
    title: {
      text: "Total Cases",
    },
    subtitle: {
      text: "Based on Account Creation Date",
    },
    background: {
      visible: false,
    },
    data: dataIn,
    theme: {
      baseTheme: "ag-vivid",
      palette: {
        fills: ["#386968"],
        strokes: ["#1F5755"],
      },
    },
    series: [
      {
        xKey: "date",
        yKey: "count",
        label: {
          enabled: false,
        },
      },
    ],
    legend: {
      enabled: false,
    },
    axes: [
      {
        type: "time",
        position: "bottom",
        label: {
          format: "%b %Y",
        },
        tick: {
          count: 4,
        },
      },
      {
        type: "number",
        position: "left",
        title: { text: "Number of cases" },
        label: {
          format: "d",
        },
      },
    ],
  };

  return chartOptions;
};

export const getCaseTotalData = (gridApi: any, lookup_key: string) => {
  const casesDayCount: { [name: string]: DataObjDict } = {};

  // const dateFilter = gridApi.getFilterInstance(lookup_key);

  // console.log("dateFilter", dateFilter);

  // iterate only nodes that pass the filter
  gridApi.forEachNode((rowNode, index) => {
    // Is Filter
    if (!rowNode.group) {
      let isRowDisplayed = rowNode.displayed;

      if (rowNode.data && rowNode.data.hasOwnProperty(lookup_key)) {
        const rowDate = rowNode.data[lookup_key];

        // 2021-08-18 20:07:24
        if (rowDate) {
          let rowDataObj = new Date();
          if (isMatch(rowDate, "yyyy-MM-dd HH:mm:ss")) {
            rowDataObj = parse(rowDate, "yyyy-MM-dd HH:mm:ss", new Date());
          } else {
            rowDataObj = parse(rowDate, "yyyy-MM-dd", new Date());
          }
           

          let foundDay = casesDayCount[rowDate];
          let dayCount = 1;

          if (foundDay) {
            dayCount += foundDay.count;
          }

          casesDayCount[rowDate] = {
            key: rowDate,
            date: rowDataObj,
            count: dayCount,
            isDisplayed: isRowDisplayed,
          };
        }
      }
    }
  });

  const dataOut: DataObjDict[] = [];

  Object.keys(casesDayCount)
    .sort((a, b) => compareAsc(casesDayCount[a].date, casesDayCount[b].date))
    .forEach((dateKey) => {
      // Add count for new day
      let thisDay = casesDayCount[dateKey];
      let thisDayCount = thisDay.count;

      // Get count of previous
      const previousDay = dataOut[dataOut.length - 1];

      if (previousDay && previousDay.count) {
        thisDayCount += previousDay.count;
      }

      dataOut.push({
        date: thisDay.date,
        key: thisDay.key,
        count: thisDayCount,
        isDisplayed: thisDay.isDisplayed,
      });
    });

  const dataOutDisplayed = dataOut.filter((val) => val.isDisplayed);

  return dataOutDisplayed;
};
